import { useEffect, useState } from 'react';
import { X } from 'lucide-react';
import { isIosSafari, getIosHintDismissed, dismissIosHint } from '../utils/installPromptUtils';
import './IosInstallHint.css';

/**
 * One-time dismissible hint for iPhone/iPad users to install via Share menu.
 * Only shows in iOS Safari, and remembers dismissal in localStorage.
 */
export function IosInstallHint() {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    if (isIosSafari() && !getIosHintDismissed()) {
      setIsVisible(true);
    }
  }, []);

  const handleDismiss = () => {
    setIsVisible(false);
    dismissIosHint();
  };

  if (!isVisible) return null;

  return (
    <div className="ios-install-hint" role="alert">
      <div className="ios-install-hint-content">
        <p>
          <strong>Install DevStackKit:</strong> Tap Share, then Add to Home Screen
        </p>
        <button
          className="ios-install-hint-close"
          onClick={handleDismiss}
          aria-label="Dismiss install hint"
        >
          <X size={16} />
        </button>
      </div>
    </div>
  );
}
